<div id="header">
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
</div>
<div bsModal #loginModal="bs-modal" class="modal fade" [config]="{backdrop: false}" tabindex="-1" role="dialog"
  aria-labelledby="loginLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid">
          <p>The email {{email}} has already been used in another application form. Do you want to proceed?</p>
          <div style="margin-top: 20px;"><button style="background-color: lightblue;"
              (click)="sendAnyWayApplicationForm()">Send Anyway</button><button
              style="float:right; background-color: lightblue;" (click)="clearFields()">No</button></div>
        </div>
      </div>
    </div>
  </div>
</div><!-- /.modal -->
<div id="application-form">
  <span (click)="goBack()" class="application-form__back-arrow"><img src="../../../../assets/img/icons/icon_back.svg" alt="Back Icon" /></span>
  <div class="container-fluid" id="container2">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <h1 *ngIf="lang === 'en'" class="container__title">Application Form</h1>
        <h1 *ngIf="lang === 'gr'" class="container__title">Φόρμα Εγγραφής</h1>
        <p *ngIf="lang === 'en'" class="container__subtitle">
          Do you have a villa, suite or luxury apartment? Join Vervendo for free and start receiving requests now!
        </p>
        <p *ngIf="lang === 'gr'" class="container__subtitle">
          Έχεις Βίλα, σουίτα ή διαμέρισμα; Έλα στην Vervendo, την πιο εξελιγμένη πλατφόρμα κρατήσεων και αύξησε τις
          πωλήσεις σου.<br><br>
          Συμπλήρωσε τα στοιχεία σου και ένας εκπρόσωπος μας θα επικοινωνήσει άμεσα μαζί σου.
        </p>
        <!--<p id="info-text">
          Do you need more information? <br>
          Fill in the form below and we'll contact you as soon as possible.
        </p>-->
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6">
        <form class="form" role="form" (ngSubmit)="sendApplicationForm()">
          <div class="row">
            <div class="col-12">
              <label *ngIf="lang === 'en'" class="form__label" for="property-name">Property Name*</label>
              <label *ngIf="lang === 'gr'" class="form__label" for="property-name">Όνομα Καταλύματος*</label>
              <input id="property-name" name="propertyname" [(ngModel)]="applicationForm.propertyname" type="text"
                class="form-control form-control-sm" required>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label *ngIf="lang === 'en'" class="form__label" for="name">First Name*</label>
              <label *ngIf="lang === 'gr'" class="form__label" for="name">Ονοματεπώνυμο*</label>
              <input id="name" name="firstname" type="text" [(ngModel)]="applicationForm.firstname"
                class="form-control form-control-sm" required>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label class="form__label" for="email">Email*</label>
              <input id="email" type="email" name="email" [(ngModel)]="applicationForm.email"
                class="form-control form-control-sm" required>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label *ngIf="lang === 'en'" class="form__label" for="phone">Phone Number (optional)</label>
              <label *ngIf="lang === 'gr'" class="form__label" for="phone">Τηλέφωνο (Προεραιτικά)</label>
              <input type="tel" id="phone" name="phone" [(ngModel)]="applicationForm.telephone"
                class="form-control form-control-sm">
            </div>
          </div>
          <!--<div class="row">
              <label class="form__label" for="message" style="margin-left:15px;">Your Message</label>
              <textarea id="message" class="form-control" rows="4"></textarea>
            </div>-->
          <div class="popup" [ngClass]="isClicked === true?'show':''">
            <span class="popuptext"
              [ngStyle]="isClicked === true?{'visibility':'visible'}:{'visibility':'hidden'}">Thank you! Your
              application has been submitted. </span>
          </div>
          <!--            <h6 id="sentText" style="visibility:hidden;">Thank you! Your application has been submitted.</h6>-->
          <button *ngIf="lang === 'en'" class="form__button" type="submit">Submit Request</button>
          <button *ngIf="lang === 'gr'" class="form__button" type="submit">Αποστολή Αιτήματος</button>
        </form>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6">
        <div class="company-info" [ngStyle]="windowChange()?{'margin-top':'40px'}:{}">
          <h4 class="company-name">Vervendo</h4>
          <p *ngIf="lang === 'en'" id="contact">Contact details</p>
          <p *ngIf="lang === 'gr'" id="contact">Στοιχεία επικοινωνίας</p>
          <div class="info-container">
            <p *ngIf="lang === 'en'" class="adress"><img src="../../../../assets/img/adress-icon.svg"
                id="adress-icon">Crete, Greece</p>
            <p *ngIf="lang === 'gr'" class="adress"><img src="../../../../assets/img/adress-icon.svg"
                id="adress-icon">Κρήτη, Ελλάδα</p>
            <p id="mail"><img src="../../../../assets/img/email-icon.svg" id="mail-icon"> info@vervendo.com</p>
            <p id="phone"><img src="../../../../assets/img/phone-icon.svg" id="phone-icon"> +30 6940470700</p>

            <div *ngIf="lang === 'en'" class="socialIcons">
              Social Media:
              <a href="https://www.facebook.com/vervendocom" (click)="angulartics2Track('ApplicationFormFb')"
                target="_blank">
                <svg class="svg__social" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook"
                  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z">
                  </path>
                </svg>
              </a>
              <a href="https://instagram.com/vervendocom" (click)="angulartics2Track('ApplicationFormInstagram')"
                target="_blank">
                <svg class="svg__social" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram"
                  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
                  </path>
                </svg>
              </a>
            </div>
            <div *ngIf="lang === 'gr'" class="socialIcons">
              Κοινωνικά Δίκτυα:
              <a href="https://www.facebook.com/vervendocom" (click)="angulartics2Track('ApplicationFormFb')"
                target="_blank">
                <svg class="svg__social" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook"
                  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z">
                  </path>
                </svg>
              </a>
              <a href="https://instagram.com/vervendocom" (click)="angulartics2Track('ApplicationFormInstagram')"
                target="_blank">
                <svg class="svg__social" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram"
                  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
                  </path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-4 desc image1"></div>
      <div class="col-lg-4 col-md-4 col-sm-4 desc image2"></div>
      <div class="col-lg-4 col-md-4 col-sm-4 desc image3"></div>
    </div> -->
  </div>
</div>